"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var sidebar_component_1 = require("./sidebar.component");
var sidebar_container_component_1 = require("./sidebar-container.component");
var sidebar_service_1 = require("./sidebar.service");
var close_directive_1 = require("./close.directive");
var SidebarModule = (function () {
    function SidebarModule() {
    }
    SidebarModule.forRoot = function () {
        return {
            ngModule: SidebarModule
        };
    };
    return SidebarModule;
}());
SidebarModule.decorators = [
    { type: core_1.NgModule, args: [{
                declarations: [sidebar_component_1.Sidebar, sidebar_container_component_1.SidebarContainer, close_directive_1.CloseSidebar],
                imports: [common_1.CommonModule],
                exports: [sidebar_component_1.Sidebar, sidebar_container_component_1.SidebarContainer, close_directive_1.CloseSidebar],
                providers: [sidebar_service_1.SidebarService]
            },] },
];
/** @nocollapse */
SidebarModule.ctorParameters = function () { return []; };
exports.SidebarModule = SidebarModule;



//////////////////
// WEBPACK FOOTER
// /Users/alexandre/Documents/web/riberfuso/resources/ng/~/ng-sidebar/lib/sidebar.module.js
// module id = ../../../../ng-sidebar/lib/sidebar.module.js
// module chunks = 9